import React, { useEffect, useCallback, useRef, useState } from "react";
import "./ConfirmDialog.css";

export default function ConfirmDialog({ message, onConfirm, onCancel, confirmLabel = "Löschen" }) {
  // While an async onConfirm runs, Enter/click could fire it again (double bulk
  // batches). Latch on the first confirm; the dialog unmounts when it resolves.
  const [busy, setBusy] = useState(false);
  const busyRef = useRef(false);
  const confirm = useCallback(() => {
    if (busyRef.current) return;
    busyRef.current = true;
    setBusy(true);
    onConfirm();
  }, [onConfirm]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === "Enter") { e.preventDefault(); confirm(); }
    if (e.key === "Escape") { e.preventDefault(); onCancel(); }
  }, [confirm, onCancel]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);

  return (
    <div className="confirm-overlay" onClick={(e) => { e.stopPropagation(); onCancel(); }}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <p className="confirm-message">{message}</p>
        <div className="confirm-actions">
          <button className="btn btn-secondary btn-sm" onClick={onCancel}>Abbrechen</button>
          <button className="btn btn-danger btn-sm" onClick={confirm} disabled={busy}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
